import { jsx as _jsx } from "react/jsx-runtime";
import { IconHighlighted as KubitIconHighlighted } from '@kubit/web-ui-components/iconHighlighted';
import { CustomContent } from './components/customContent';
export const IconHighlighted = ({ badgeIcon, badgeLogo, selectorIcon, ...props }) => {
    return (_jsx(KubitIconHighlighted, { ...props, 
        // invoke CustomContent as a function to pass as prop fully evaluated (to null or JSX.Element)
        customContent: CustomContent({
            badgeIcon,
            badgeLogo,
            disabled: props.disabled,
            selected: props.selected,
            selectorIcon,
        }) }));
};
//# sourceMappingURL=iconHighlighted.js.map